export default "__VITE_ASSET__COpw$390__"